var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.846,
    height: 15.877,
    viewBox: "0 0 19.846 15.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    "data-name": "Icon awesome-user-check",
    d: "M6.946,7.938A3.969,3.969,0,1,0,2.977,3.969,3.969,3.969,0,0,0,6.946,7.938Zm2.778.992H9.207a5.4,5.4,0,0,1-4.521,0H4.168A4.169,4.169,0,0,0,0,13.1v1.29a1.489,1.489,0,0,0,1.488,1.488H12.4a1.489,1.489,0,0,0,1.488-1.488V13.1A4.169,4.169,0,0,0,9.725,8.931ZM19.741,4.949l-.862-.871a.368.368,0,0,0-.521,0L15.108,7.3,13.7,5.879a.368.368,0,0,0-.521,0l-.871.865a.368.368,0,0,0,0,.521l2.533,2.552a.368.368,0,0,0,.521,0L19.738,5.47A.371.371,0,0,0,19.741,4.949Z",
    fill: "#16d696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerUserCheck);
export default __webpack_public_path__ + "static/media/banner-user-check.2342799c1e2bab77722c4e128e549629.svg";
export { ForwardRef as ReactComponent };